export default settings => {
    return ({ value }) => {
        return `P${value}`;
    };
};
